import capitalize from 'capitalize';

export default function capitalizeWords(str: string): string {
  return capitalize.words(str);
}
